/* eslint-disable no-unused-vars */
import Vue from 'vue';
import VueRouter from 'vue-router';
import jsonwebtoken from 'jsonwebtoken';
import axios from 'axios';

Vue.use(VueRouter);

const SITE_NAME = 'Movevai';

const routes = [
  {
    path: '/',
    name: 'MainTemplate',
    component: () => import(/* webpackChunkName: "main-template" */ '../views/MainTemplate.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
      },
      {
        path: 'services',
        name: 'Services',
        meta: {
          title: 'บริการของเรา'
        },
        component: () => import(/* webpackChunkName: "services" */ '../views/Services.vue')
      },
      {
        path: 'services/:name',
        name: 'ServicesDetails',
        meta: {
          title: 'รายละเอียดบริการ'
        },
        component: () => import(/* webpackChunkName: "services-details" */ '../views/service/Details.vue')
      },
      {
        path: 'about',
        name: 'About',
        meta: {
          title: 'เกี่ยวกับเรา'
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
      },
      {
        path: '/announcement',
        name: 'Announcement',
        meta: {
          title: 'ข่าวประชาสัมพันธ์'
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "announcement" */ '../views/Announcement.vue')
      },
      {
        path: '/announcement/home',
        name: 'AnnouncementHome',
        meta: {
          title: 'ข่าวประชาสัมพันธ์'
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "announcement-home" */ '../views/announcement/Home.vue')
      },
      {
        path: '/announcement/:id',
        name: 'AnnouncementDetails',
        meta: {
          title: 'ข่าวประชาสัมพันธ์'
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "announcement-details" */ '../views/announcement/Details.vue')
      },
      {
        path: '/contact',
        name: 'Contact',
        meta: {
          title: 'ติดต่อเรา'
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue')
      },
      {
        path: '/status',
        name: 'Status',
        meta: {
          title: 'เช็คสถานะสินค้า'
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "status" */ '../views/Status.vue')
      },
      {
        path: '/messenger/privacy',
        name: 'MessengerPrivacy',
        meta: {
          title: 'นโยบายความเป็นส่วนตัว Messenger'
        },
        component: () => import(/* webpackChunkName: "messenger-privacy" */ '../views/messenger/Privacy.vue')
      },
      {
        path: '/messenger/account-deletion',
        name: 'MessengerAccountDeletion',
        meta: {
          title: 'คำขอลบบัญชี Messenger'
        },
        component: () => import(/* webpackChunkName: "messenger-account-deletion" */ '../views/messenger/AccountDeletion.vue')
      },
      {
        path: '/messenger/legal-preview',
        name: 'MessengerLegalPreview',
        meta: {
          title: 'พรีวิวศูนย์ความเป็นส่วนตัว Messenger'
        },
        component: () => import(/* webpackChunkName: "messenger-legal-preview" */ '../views/messenger/LegalPreview.vue')
      },
      {
        path: '/order/home',
        name: 'OrderHome',
        meta: {
          requiresAuth: true,
          title: 'ส่งสินค้า'
        },
        component: () => import(/* webpackChunkName: "order-home" */ '../views/order/Home.vue')
      },
      {
        path: '/my-order',
        name: 'MyOrder',
        meta: {
          requiresAuth: true,
          title: 'รายการของฉัน'
        },
        component: () => import(/* webpackChunkName: "order-home" */ '../views/MyOrder.vue')
      },
      {
        path: '/order/:id',
        name: 'OrderDetails',
        meta: {
          requiresAuth: true,
          title: 'รายละเอียดรายการ'
        },
        component: () => import(/* webpackChunkName: "order-details" */ '../views/JobDetails.vue')
      },
      {
        path: '/my-profile',
        name: 'MyProfile',
        meta: {
          title: 'แก้ไขข้อมูลส่วนตัว'
        },
        component: () => import(/* webpackChunkName: "my-profile" */ '../views/MyProfile.vue')
      },
      {
        path: '/forgot-password',
        name: 'ForgotPassword',
        meta: {
          title: 'ลืมรหัสผ่าน'
        },
        component: () => import(/* webpackChunkName: "forgot-password" */ '../views/ForgotPassword.vue')
      },
      {
        path: '/reset-password',
        name: 'ResetPassword',
        meta: {
          title: 'ตั้งรหัสผ่านใหม่'
        },
        component: () => import(/* webpackChunkName: "reset-password" */ '../views/ResetPassword.vue')
      },
      {
        path: '/login',
        name: 'Login',
        meta: {
          title: 'เข้าสู่ระบบ'
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
      },
      {
        path: '/register',
        name: 'Register',
        meta: {
          title: 'สมัครสมาชิก'
        },
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue')
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) { // keep the previous spot when using browser back / forward
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const jwt = localStorage.getItem('jwt') ? localStorage.getItem('jwt') : null;
  if (jwt) { // handle expire!
    const decoded = jsonwebtoken.decode(jwt);
    const expireTime = decoded.exp;
    const currentTime = Math.floor((new Date()).getTime() / 1000);
    if (expireTime <= currentTime) {
      const name = to.name;
      localStorage.removeItem('jwt');
      return next({ name: 'Login', params: { nextUrl: name } });
    }
  }

  // set global header
  axios.defaults.headers = {
    Authorization: 'Bearer ' + jwt
  };

  // prevent login page after sign in already.
  if ('Login' === to.name && jwt) {
    return next({ name: 'Home' });
  }

  // require authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!jwt) {
      return next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      });
    }
  }
  next();
});

router.afterEach((to) => { // page title per route, falls back to the site name
  const title = to.meta && to.meta.title;
  document.title = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
});

export default router;
